var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  default: () => getDSDataAtPath
});
module.exports = __toCommonJS(stdin_exports);
function getDSDataAtPath(data, path) {
  const parts = typeof path === "string" ? path.split("/").filter(Boolean) : path;
  let ptr = data;
  while (ptr && parts.length) {
    const part = parts.shift();
    if (Array.isArray(ptr) && Number.isNaN(+part))
      ptr = ptr.find((x) => x.id === part);
    else
      ptr = ptr[part];
  }
  return ptr;
}
